import React from 'react';
import LegalPage from './LegalPage';

const CancellationPolicyPage = () => {
  return (
    <LegalPage title="Cancellation Policy" slug="cancellation-policy" lastUpdated="January 2026">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">1. Order Cancellation Window</h2>
        <p className="text-zinc-700 leading-relaxed">
          Orders can be cancelled within 2 hours of placement. After this window, the order enters our processing system and cannot be cancelled online.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">2. How to Cancel Your Order</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">To cancel an order:</p>
        <ol className="list-decimal pl-6 text-zinc-700 space-y-2">
          <li>Log into your account or use your order ID</li>
          <li>Go to "My Orders" section</li>
          <li>Select the order you want to cancel</li>
          <li>Click "Cancel Order" button</li>
          <li>Choose cancellation reason and confirm</li>
        </ol>
        <p className="text-zinc-700 leading-relaxed mt-3">
          Alternatively, contact our customer support team immediately with your order ID to cancel.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">3. Cancellation After Processing</h2>
        <p className="text-zinc-700 leading-relaxed">
          If your order has already been shipped, you cannot cancel it. However, you can refuse delivery or return the product as per our Return Policy once received.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">4. Refund for Cancelled Orders</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">Refund processing:</p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li><strong>Online Payments:</strong> Full refund to original payment method within 5-7 business days</li>
          <li><strong>COD Orders:</strong> No payment made, cancellation processed immediately</li>
          <li><strong>Wallet/UPI:</strong> Instant or same-day refund in most cases</li>
          <li><strong>Credit/Debit Cards:</strong> 5-7 business days depending on your bank</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">5. Partial Cancellation</h2>
        <p className="text-zinc-700 leading-relaxed">
          If your order contains multiple items, you can cancel individual items within the 2-hour window. The refund will be processed for the cancelled items only.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">6. Seller-Initiated Cancellation</h2>
        <p className="text-zinc-700 leading-relaxed mb-3">
          We reserve the right to cancel orders in the following situations:
        </p>
        <ul className="list-disc pl-6 text-zinc-700 space-y-2">
          <li>Product is out of stock or unavailable</li>
          <li>Pricing or product information error</li>
          <li>Payment verification failure</li>
          <li>Delivery address is unserviceable</li>
          <li>Suspected fraudulent activity</li>
        </ul>
        <p className="text-zinc-700 leading-relaxed mt-3">
          In such cases, you will be notified immediately and receive a full refund.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">7. Cancellation Charges</h2>
        <p className="text-zinc-700 leading-relaxed">
          We do not charge any cancellation fees for orders cancelled within the 2-hour window or for seller-initiated cancellations. Full refund will be processed in all eligible cases.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">8. Modification vs Cancellation</h2>
        <p className="text-zinc-700 leading-relaxed">
          If you need to change your order details (address, items, etc.), contact us within 2 hours. We'll try to modify the order instead of cancelling if possible.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold text-[#0f172a] mb-4">9. Contact for Cancellations</h2>
        <p className="text-zinc-700 leading-relaxed">
          For urgent cancellation requests or queries:<br />
          Email: support@indicraft.in<br />
          Phone: +91 123-456-7890<br />
          WhatsApp: +91 123-456-7890<br />
          Available: Monday-Saturday, 9 AM - 7 PM IST
        </p>
      </section>
    </LegalPage>
  );
};

export default CancellationPolicyPage;
